export type DiscountType = 'percentage' | 'flat_rate' | 'free';
export type GroupScope = 'all_host_chargers' | 'specific_chargers';

export interface PricingGroupCharger {
    charger_id: string;
    charger_name: string | null;
    is_enabled: boolean;
}

export interface PricingGroupMember {
    id: string;
    user_id: string | null;
    user_email: string;
    status: 'active' | 'revoked';
    created_at: string;
}

export interface PricingGroup {
    id: string;
    name: string;
    discount_type: DiscountType;
    discount_value: number;
    scope: GroupScope;
    is_active: boolean;
    member_count?: number;
    charger_count?: number;
    created_at: string;
    updated_at?: string;
    chargers?: PricingGroupCharger[];
    members?: PricingGroupMember[];
}

export interface CreatePricingGroupPayload {
    name: string;
    discount_type: DiscountType;
    discount_value: number;
    scope: GroupScope;
    charger_ids?: string[];
}

export interface UpdatePricingGroupPayload {
    name?: string;
    discount_type?: DiscountType;
    discount_value?: number;
    scope?: GroupScope;
    is_active?: boolean;
    charger_ids?: string[];
}

export interface PricingGroupListResponse {
    groups: PricingGroup[];
}

export const DISCOUNT_BADGE_COLORS: Record<DiscountType, string> = {
    free: '#10B981',
    percentage: '#3B82F6',
    flat_rate: '#F59E0B',
};

export const formatDiscountLabel = (type: DiscountType, value: number): string => {
    switch (type) {
        case 'free':
            return 'FREE';
        case 'percentage':
            return `${value}% Off`;
        case 'flat_rate':
            return `$${value.toFixed(3)}`;
    }
};

export const formatDiscountShort = (type: DiscountType, value: number): string => {
    switch (type) {
        case 'free':
            return 'FREE';
        case 'percentage':
            return `-${value}%`;
        case 'flat_rate':
            return `$${value.toFixed(3)}`;
    }
};
